import { useState } from "react";

import PrimaryButton from "../../../Components/Buttons/primary-button";

import renderStakeCheckingOnboardingStep from "../Stake Checking Status/stake-checking-onboarding-step";

import { useModalContext } from "../../../Contexts/ModalContext";

import { useStakeDebit } from "../../../CustomHooks/Queries";

import { modalVariants } from "../../../Utils/constants";

import { StakeCardFrontRotated } from "../../../Assets/Images";

export default function renderApplyStakeChecking(modalContext, props) {
  const { updateModalComponent, setModalVariant, setModalClassName, setModalPromoComponent } = modalContext;

  updateModalComponent(() => <ApplyStakeChecking {...props} />);
  setModalPromoComponent(null);
  setModalVariant(modalVariants.flexDialog);
  setModalClassName("position-close-button-over-content light-close-button");
}

const ApplyStakeChecking = ({ applyOnMount, ...props }) => {
  const [renderApplyDialog, setRenderApplyDialog] = useState(false);

  const modalContext = useModalContext();

  const { data: stakeDebit } = useStakeDebit();

  const handleNextButtonClick = () => {
    if (!renderApplyDialog) {
      setRenderApplyDialog(true);
    } else {
      renderStakeCheckingOnboardingStep(modalContext)
    }
  };

  return (
    <>
      <div className="modal-image-carousel position-relative">
        <div className="modal-image stake-debit-single-card">
          <img src={StakeCardFrontRotated} alt="" />
        </div>
        <div className="carousel-indicators" role="tablist" aria-label="Stake Checking intro slides">
          {Array.from(new Array(2)).map((_, idx) => {
            const isCurrent = !!renderApplyDialog === !!idx;
            return (
              <button
                key={idx}
                type="button"
                data-bs-target=""
                className={isCurrent ? "active" : ""}
                onClick={() => setRenderApplyDialog(!!idx)}
                aria-label={`Go to slide ${idx + 1} of 2`}
                aria-current={isCurrent ? "true" : undefined}
              ></button>
            );
          })}
        </div>
      </div>
      <div className="modal-dialog-content">
        <h3 className="modal-status-title text-center mb-0">
          {!renderApplyDialog
            ? stakeDebit?.data?.data?.card_onboarding_page_1_header
            : stakeDebit?.data?.data?.card_onboarding_page_2_header}
        </h3>
        <span className="modal-content-text text-center mt-1">
          {!renderApplyDialog
            ? stakeDebit?.data?.data?.card_onboarding_page_1_body
            : stakeDebit?.data?.data?.card_onboarding_page_2_body}
        </span>
      </div>
      <div className="action-container">
        <PrimaryButton onClick={handleNextButtonClick}>{!renderApplyDialog ? "Next" : "Apply Now"}</PrimaryButton>
        {renderApplyDialog && (
          <PrimaryButton className="secondary-colors" onClick={setRenderApplyDialog.bind(this, false)}>
            Back
          </PrimaryButton>
        )}
      </div>
      {renderApplyDialog && !!stakeDebit?.data?.data?.disclosure_text && (
        <span className="text-xxs-regular color--american-silver text-center mt-0 mb-4 mx-sm-6 mx-4">
          {stakeDebit?.data?.data?.disclosure_text}
        </span>
      )}
    </>
  );
};
